import Modal from "react-bootstrap/Modal";
import React, { useState } from "react";
import Button from "react-bootstrap/Button";

function ConfirmDialog(props) {
  return (
    <Modal show={props.show} onHide={props.handleCancel} animation={false}>
      <Modal.Header closeButton>
        <Modal.Title>{props.messageTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{props.messageBody}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={props.handleCancel}>
          Cancel
        </Button>
        <Button variant="primary" onClick={props.handleAccept}>
          Accept
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ConfirmDialog;
